<template>
  <div class="card shadow-sm">
    <br>
    <div class="card-body">

      <!-- Procedimiento -->
      <div class="mb-3">
        <label class="form-label fw-bold">Procedimiento</label>
        <div class="btn-group w-100" role="group">
          <button
            v-for="(m, key) in MODOS"
            :key="key"
            type="button"
            class="btn"
            :class="modo === key ? 'btn-primary' : 'btn-outline-primary'"
            :disabled="cargando"
            @click="modo = key"
          >
            {{ m.label }}
          </button>
        </div>
        <div class="form-text">{{ MODOS[modo].ayuda }}</div>
      </div>

      <!-- Contexto (viene de parámetros / consulta, no se digita) -->
      <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
        <span class="badge text-bg-secondary">Prestador: {{ p_idPrestador }}</span>
        <span class="badge text-bg-secondary">Nivel: {{ p_nivel }}</span>
        <span v-if="esEle" class="badge text-bg-secondary">Clase de elemento: {{ idClasElem }}</span>

        <span v-if="cargandoConv" class="badge text-bg-light text-dark">
          <span class="spinner-border spinner-border-sm me-1"></span>
          Consultando convenio...
        </span>
        <span
          v-else-if="tarifasConv.length === 1"
          class="badge text-bg-secondary"
        >
          Tarifa convenio: {{ form.idTarifaConv }}
        </span>
      </div>

      <div class="row g-3 align-items-end">
        <!-- Tarifa convenio (solo si el prestador tiene más de una) -->
        <div v-if="tarifasConv.length > 1" class="col-12 col-md-3">
          <label class="form-label fw-bold">Tarifa Convenio</label>
          <select
            class="form-select"
            v-model.number="form.idTarifaConv"
            :class="{ 'is-invalid': errores.idTarifaConv }"
          >
            <option v-for="t in tarifasConv" :key="t.idTarifaConv" :value="t.idTarifaConv">
              {{ t.idTarifaConv }}
            </option>
          </select>
          <div class="invalid-feedback">{{ errores.idTarifaConv }}</div>
        </div>

        <!-- Usuario -->
        <div class="col-12 col-md-3">
          <label class="form-label fw-bold">ID Usuario</label>
          <input
            type="number"
            min="1"
            class="form-control"
            v-model.number="form.idUsuario"
            placeholder="Ej: 2"
            :class="{ 'is-invalid': errores.idUsuario }"
          />
          <div class="invalid-feedback">{{ errores.idUsuario }}</div>
        </div>

        <!-- Archivo CSV -->
        <div class="col-12 col-md-6">
          <label class="form-label fw-bold">Archivo CSV</label>
          <input
            ref="inputArchivo"
            type="file"
            class="form-control"
            accept=".csv,text/csv"
            :disabled="cargando"
            :class="{ 'is-invalid': errores.archivo }"
            @change="onArchivo"
          />
          <div class="invalid-feedback">{{ errores.archivo }}</div>
          <div v-if="archivo" class="form-text">
            {{ archivo.name }} · {{ (archivo.size / 1024).toFixed(1) }} KB
          </div>
        </div>

        <!-- Simular -->
        <div class="col-12 col-md-3">
          <div class="form-check form-switch">
            <input
              class="form-check-input"
              type="checkbox"
              id="chkSimular"
              v-model="form.simular"
            />
            <label class="form-check-label fw-bold" for="chkSimular">Simular</label>
          </div>
        </div>

        <!-- Botón -->
        <div class="col-12 col-md-3 ms-md-auto">
          <button
            class="btn w-100 d-flex align-items-center justify-content-center gap-1"
            :class="form.simular ? 'btn-primary' : 'btn-danger'"
            @click="ejecutar"
            :disabled="cargando || cargandoConv"
          >
            <span v-if="cargando" class="spinner-border spinner-border-sm"></span>
            <span v-else class="material-icons" style="font-size:18px">
              {{ form.simular ? 'science' : 'play_arrow' }}
            </span>
            {{ cargando ? 'Procesando...' : form.simular ? 'Simular' : 'Ejecutar' }}
          </button>
        </div>
      </div>

      <!-- Progreso de subida -->
      <div v-if="cargando" class="mt-3">
        <div class="progress" style="height: 20px">
          <div
            class="progress-bar"
            :class="{ 'progress-bar-striped progress-bar-animated': progreso >= 100 }"
            role="progressbar"
            :style="{ width: progreso + '%' }"
          >
            {{ progreso >= 100 ? 'Procesando en el servidor...' : progreso + '%' }}
          </div>
        </div>
      </div>

      <!-- Resultado -->
      <div v-if="mensaje" class="mt-3 alert" :class="mensajeClase">
        {{ mensaje }}
      </div>

      <div v-if="avisos.length" class="mt-3">
        <div class="d-flex flex-wrap align-items-center gap-2 mb-2">
          <button
            v-for="f in FILTROS"
            :key="f"
            type="button"
            class="btn btn-sm"
            :class="filtro === f ? 'btn-dark' : 'btn-outline-secondary'"
            @click="filtro = f"
          >
            {{ f }} ({{ conteos[f] }})
          </button>

          <button
            type="button"
            class="btn btn-sm btn-outline-primary ms-auto d-flex align-items-center gap-1"
            @click="descargarLog"
          >
            <span class="material-icons" style="font-size:16px">download</span>
            Descargar log
          </button>
        </div>

        <ul class="list-group avisos-lista">
          <li
            v-for="(a, i) in avisosFiltrados"
            :key="i"
            class="list-group-item py-1 small font-monospace"
            :class="claseAviso(a.tipo)"
          >
            {{ a.texto }}
          </li>
          <li v-if="!avisosFiltrados.length" class="list-group-item py-1 small text-muted">
            Sin mensajes para este filtro.
          </li>
        </ul>
      </div>

    </div>
  </div>
</template>

<script>
import api  from "@/services/api";
import Swal from "sweetalert2";

// El backend recibe el archivo y el modo ("simple" | "ele") en un único endpoint
const RUTA_UPLOAD = "/procedimientos/cargar-tarifa-pres-csv-upload";

const MODOS = {
  simple: {
    label: "Solo tarifas",
    ayuda:
      "CSV: codigo;valor. No crea elementos: los códigos inexistentes se omiten. Todas las tarifas quedan activas.",
  },
  ele: {
    label: "Elementos + tarifas",
    ayuda:
      "CSV (LATIN1): codigo;descripcion;valor;estado. Crea elementos nuevos y sincroniza estados. " +
      "Un valor vacío o no numérico se carga como 0.",
  },
};

const FILTROS = ["TODOS", "INSERT", "UPDATE", "ELEMENTO", "SKIP", "INFO"];

function clasificar(aviso) {
  if (aviso.startsWith("[SKIP]"))            return "SKIP";
  if (aviso.startsWith("[INSERT ELEMENTO]")) return "ELEMENTO";
  if (aviso.startsWith("[UPDATE ELEMENTO]")) return "ELEMENTO";
  if (aviso.startsWith("[INSERT]"))          return "INSERT";
  if (aviso.startsWith("[UPDATE]"))          return "UPDATE";
  return "INFO";
}

export default {
  name: "CargaTarifaPresCsvForm",
  props: {
    p_idPrestador: { type: Number, required: true },
    p_nivel:       { type: Number, required: true },
    p_idUsuario:   { type: Number, default: null },
  },
  data() {
    return {
      MODOS,
      FILTROS,
      modo: "simple",
      form: {
        idTarifaConv: null,
        idUsuario:    this.p_idUsuario,
        simular:      true, // por seguridad, siempre arranca en simulación
      },
      archivo:      null,
      progreso:     0,
      tarifasConv:  [],
      cargandoConv: false,
      errores:      {},
      cargando:     false,
      mensaje:      "",
      mensajeClase: "",
      avisos:       [],
      filtro:       "TODOS",
    };
  },
  computed: {
    esEle() {
      return this.modo === "ele";
    },
    // 11 => 11, 10 => 10, cualquier otro prestador => 2
    idClasElem() {
      if (this.p_idPrestador === 11) return 11;
      if (this.p_idPrestador === 10) return 10;
      return 2;
    },
    avisosClasificados() {
      return this.avisos.map((texto) => ({ texto, tipo: clasificar(texto) }));
    },
    conteos() {
      const c = { TODOS: this.avisosClasificados.length, INSERT: 0, UPDATE: 0, SKIP: 0, ELEMENTO: 0, INFO: 0 };
      this.avisosClasificados.forEach((a) => c[a.tipo]++);
      return c;
    },
    avisosFiltrados() {
      return this.filtro === "TODOS"
        ? this.avisosClasificados
        : this.avisosClasificados.filter((a) => a.tipo === this.filtro);
    },
  },
  watch: {
    p_idPrestador: "cargarConvenios",
  },
  mounted() {
    this.cargarConvenios();
  },
  methods: {
    async cargarConvenios() {
      this.cargandoConv      = true;
      this.tarifasConv       = [];
      this.form.idTarifaConv = null;
      this.errores           = {};
      try {
        const { data } = await api.get(`/vwtarifaconvs/idprestador/${this.p_idPrestador}`);
        this.tarifasConv = Array.isArray(data) ? data : [];

        if (this.tarifasConv.length === 0) {
          this.mensaje      = "El prestador no tiene una tarifa de convenio configurada.";
          this.mensajeClase = "alert-warning";
          return;
        }
        // Por defecto, la primera; si hay varias se muestra un select
        this.form.idTarifaConv = this.tarifasConv[0].idTarifaConv;
      } catch (error) {
        const msg =
          typeof error.response?.data === "string"
            ? error.response.data
            : error.response?.data?.message
            ?? error.response?.data?.error
            ?? error.message
            ?? "Error desconocido";
        this.mensaje      = `No se pudo obtener la tarifa de convenio: ${msg}`;
        this.mensajeClase = "alert-danger";
      } finally {
        this.cargandoConv = false;
      }
    },

    onArchivo(e) {
      this.archivo = e.target.files[0] || null;
      this.errores = {};
    },

    validar() {
      this.errores = {};
      const f = this.form;

      if (!f.idTarifaConv)
        this.errores.idTarifaConv = "No hay tarifa de convenio para este prestador.";

      if (!f.idUsuario)
        this.errores.idUsuario = "El usuario es obligatorio.";

      if (!this.archivo)
        this.errores.archivo = "Seleccione un archivo CSV.";
      else if (!this.archivo.name.toLowerCase().endsWith(".csv"))
        this.errores.archivo = "El archivo debe tener extensión .csv.";

      return Object.keys(this.errores).length === 0;
    },

    claseAviso(tipo) {
      return {
        INSERT:   "list-group-item-success",
        UPDATE:   "list-group-item-info",
        ELEMENTO: "list-group-item-primary",
        SKIP:     "list-group-item-warning",
        INFO:     "",
      }[tipo];
    },

    async ejecutar() {
      if (!this.validar()) {
        if (this.errores.idTarifaConv) {
          Swal.fire({ icon: "warning", title: "Sin convenio", text: this.errores.idTarifaConv });
        }
        return;
      }

      if (!this.form.simular) {
        const r = await Swal.fire({
          icon: "warning",
          title: "Carga REAL",
          text: "Se modificarán datos en la base de datos. ¿Desea continuar?",
          showCancelButton: true,
          confirmButtonText: "Sí, ejecutar",
          cancelButtonText: "Cancelar",
        });
        if (!r.isConfirmed) return;
      }

      const formData = new FormData();
      formData.append("file", this.archivo);
      formData.append("modo", this.modo);
      formData.append("idPrestador", this.p_idPrestador);
      formData.append("nivel", this.p_nivel);
      formData.append("idTarifaConv", this.form.idTarifaConv);
      formData.append("idUsuario", this.form.idUsuario);
      formData.append("simular", this.form.simular);
      if (this.esEle) formData.append("idClasElem", this.idClasElem);

      this.cargando = true;
      this.progreso = 0;
      this.mensaje  = "";
      this.avisos   = [];
      this.filtro   = "TODOS";

      try {
        const response = await api.post(RUTA_UPLOAD, formData, {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (evt) => {
            if (evt.total) this.progreso = Math.round((evt.loaded * 100) / evt.total);
          },
        });
        const { mensaje, avisos } = response.data;

        this.avisos       = avisos || [];
        this.mensajeClase = this.form.simular ? "alert-warning" : "alert-success";
        this.mensaje      = `${this.form.simular ? "⚠ " : "✓ "}${mensaje}`;

        // Tras una carga real se limpia el archivo; tras una simulación se conserva
        // para poder ejecutar la carga real con el mismo archivo.
        if (!this.form.simular) {
          this.archivo = null;
          if (this.$refs.inputArchivo) this.$refs.inputArchivo.value = "";
        }
      } catch (error) {
        console.error("Error al cargar tarifas:", error);
        const msg =
          typeof error.response?.data === "string"
            ? error.response.data
            : error.response?.data?.message
            ?? error.response?.data?.error
            ?? error.message
            ?? "Error desconocido";
        this.mensaje      = msg;
        this.mensajeClase = "alert-danger";
        Swal.fire({ icon: "error", title: "Error", text: msg });
      } finally {
        this.cargando = false;
        this.progreso = 0;
      }
    },

    descargarLog() {
      const blob = new Blob([this.avisos.join("\n")], { type: "text/plain;charset=utf-8" });
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement("a");
      a.href     = url;
      a.download = `log_carga_tarifa_${Date.now()}.txt`;
      a.click();
      URL.revokeObjectURL(url);
    },
  },
};
</script>

<style scoped>
.avisos-lista {
  max-height: 420px;
  overflow: auto;
}
</style>